module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box",
    class: {
      leader: _vm.info.bu_identity_type == 1
    },
    on: {
      "click": _vm.clerkInfo
    }
  }, [_c('z-lazyImg', {
    staticClass: "box-left",
    attrs: {
      "src": _vm.info.user_logo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-right"
  }, [_c('div', {
    staticClass: "box-right-top"
  }, [_vm._v(_vm._s(_vm.info.real_name)), (_vm.info.ticket_from_manager !== 0) ? _c('span', {
    staticClass: "point"
  }, [_vm._v(" ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-right-middle"
  }, [_c('div', {
    staticClass: "box-right-middle-left"
  }, [_c('div', [_vm._v("工号：" + _vm._s(_vm.info.user_name))]), _vm._v(" "), _c('div', [_vm._v("岗位：" + _vm._s(_vm.info.position_name))]), _vm._v(" "), _c('div', [_vm._v("年限：" + _vm._s(_vm._f("workAge")(_vm.info.work_date)))])]), _vm._v(" "), _c('div', {
    staticClass: "box-right-middle-right"
  }, [_c('div', [_vm._v("身份：" + _vm._s(_vm.info.bu_identity_type == 1 ? "BU合伙人" : "职员"))]), _vm._v(" "), _c('div', [_vm._v("职级：" + _vm._s(_vm.info.staffing_grade) + "级")]), _vm._v(" "), _c('div', [_vm._v("生日：" + _vm._s(_vm._f("justDate")(_vm.info.birth_date)))])]), _vm._v(" "), _c('div', [_vm._v("入职时间：" + _vm._s(_vm._f("justDate")(_vm.info.work_date)))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-646f0df8!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/frontStage/buManage/personBox.vue
// module id = 753
// module chunks = 1